import React from 'react';
import './select-atack.css';
import classData from '../../datasets/class-detail.json';
import Options from "../../components/options/options";
import socketService from "../../services/socket";
import Icon from "../../components/icon/icon";

function SelectAtack({classSelected, roomCode}) {
    const selectedClass = classData.classes.find(cls => cls?.nome?.toLowerCase() === classSelected?.nome.toLowerCase());

    return (
        <div className="your-turn">
            <h3>É seu turno, selecione o ataque:</h3>
            {selectedClass && selectedClass.ataques.map((ataque, index) => (
                <Options method={() => {
                    socketService.emit('attack', { roomCode, attackIndex: index });
                }}>
                    <div>
                        {ataque.nome} <br/>
                        <Icon icon={'sword'} style={{width: 15}} title={ataque.dano_fisico} />
                        <Icon icon={'magic'} style={{width: 15}} title={ataque.dano_magico} />
                        <Icon icon={'mana'} style={{width: 15}} title={ataque.custo_mana} />
                    </div>
                </Options>
            ))}
            <Options method={() => {
                    socketService.emit('attack', { roomCode, attackIndex: null });
            }}>
                <div>
                    Ignorar ataque <br/>
                    <Icon icon={'sword'} style={{width: 15}} title={0} />
                    <Icon icon={'magic'} style={{width: 15}} title={0} />
                    <Icon icon={'mana'} style={{width: 15}} title={0} />
                </div>
            </Options>
        </div>
    );
}

export default SelectAtack;